import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faInstagram,
  faGooglePlus, 
} from '@fortawesome/free-brands-svg-icons';
import './style.css'

const LINKS = [
  { brand: 'facebook',  icon: faFacebookF,  label: 'Facebook' },
  { brand: 'twitter',   icon: faXTwitter,   label: 'Twitter' },
  { brand: 'google',    icon: faGooglePlus, label: 'Google Plus' },
  { brand: 'linkedin',  icon: faLinkedinIn, label: 'LinkedIn' },
  { brand: 'instagram', icon: faInstagram,  label: 'Instagram' },
];

export const SocialIconsB = () => (
  <ul className="socialB-list">
    {LINKS.map(({ brand, icon, label }) => (
      <li className="socialB-item" data-brand={brand} aria-label={label} key={brand}>
        <span className="socialB-inner">
          <FontAwesomeIcon icon={icon} />
        </span>
      </li>
    ))}
  </ul>
);
